import { render, staticRenderFns } from "./EntityRelationship.vue?vue&type=template&id=1989ea81"
import script from "./EntityRelationship.vue?vue&type=script&lang=js"
export * from "./EntityRelationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports